import { cn } from "@drpcrd/utils/shared";
import { GradientIcon } from "../icons/gradient-icon";
import { Typography } from "../index";
import { Card } from "./card";
import { LucideIcon } from "lucide-react";

type Props = {
  title: string;
  subtitle: string;
  icon: LucideIcon;
  onClick?: () => void;
};

/**
 * Chat suggestion card used to display suggested prompts to the user based on
 * the selected agent and conversation context.
 *
 * Note: The gradient border is not able to use the pre-existing classes so we
 * wrap the body of the card within a div that has the gradient background
 *
 */
export const ChatSuggestionCard = ({
  title,
  subtitle,
  icon,
  onClick,
}: Props) => (
  <Card
    onClick={onClick}
    className={cn(
      "rounded-xl border-none p-0 p-px transition-all",
      onClick
        ? "hover:from-primary hover:shadow-light bg-neutral-500 hover:bg-gradient-to-r hover:to-pink-500"
        : "opacity-75",
    )}
  >
    {/* We need to make this 1px smaller than the card radius as it is 1px smaller from p-px */}
    <div className="rounded-[11px] bg-white p-2">
      <GradientIcon icon={icon} size={24} />

      <Typography size="lg" weight="semibold" className="text-black">
        {title}
      </Typography>
      <Typography size="sm" className={cn("hidden text-gray-500 sm:block")}>
        {subtitle}
      </Typography>
    </div>
  </Card>
);
